import React from 'react';
import { PictureWithFallback } from '../../../sections/PictureWithFallback';
import { format } from 'date-fns';

type Props = {
    picture?: string;
    message: {
        message: string;
        date: string;
    };
};

export const AdminIncomingChatBubble: React.FC<Props> = ({ picture, message }) => {
    const author = 'Stay Plugged In';

    return (
        <div className="chat-bubble admin">
            <div className="image-wrapper">
                <PictureWithFallback width={40} height={40} icon={picture} alt={`${author}'s profile image`} />
            </div>
            <div className="message-container">
                <div className="bubble formatted-content" dangerouslySetInnerHTML={{ __html: message.message }} />
                <div className="message-stamp">
                    <span className="author">{author}</span>
                    {author && <>{'-'}</>}
                    <span className="timestamp">{format(new Date(message.date), 'MMM d, y, h:mm a')}</span>
                </div>
            </div>
        </div>
    );
};
